import { inject } from 'mobx-react';
import { TemplateComponent, TemplateComponentProps } from 'experience-template-renderer-react';
import * as React from 'react';

import { CustomerNotificationLocation } from '@shared-ui/customer-notifications';

import { SearchResultsStore } from 'stores/search-results-store';

import { CustomerNotifications } from 'components/common/customer-notifications';

interface CustomerNotificationTemplateProps extends TemplateComponent {
  config: {
    location: CustomerNotificationLocation;
  };
}

export interface CustomerNotificationTemplateComponentProps extends TemplateComponentProps {
  templateComponent: CustomerNotificationTemplateProps;
  searchResults: SearchResultsStore;
}

export const CustomerNotificationTemplateComponent: React.FC<CustomerNotificationTemplateComponentProps> = inject('searchResults')(
  ({ templateComponent, searchResults }) => {
    const { config } = templateComponent;

    const searchCriteria = searchResults?.searchCriteria;
    const { regionId, startDate, endDate } = searchCriteria || {};

    return <CustomerNotifications location={config?.location} regionId={regionId} startDate={startDate} endDate={endDate} />;
  }
);
